import { CONFIG } from '../config.js';

export const formValidations = {
	validMobileFormat,
	validEmailFormat,
	validBirthDateFormat,
	validNameFormat,
	noInputError,
	requiredInputFieldErrorMsg,
	requiredEmailFieldErrorMsg,
	requiredBirthDateFieldErrorMsg,
	requiredTourPackageFieldErrorMsg,
	requiredNameFieldErrorMsg,
	requiredMobileFieldErrorMsg,
	requiredAmountFieldErrorMsg,
	requiredAddressFieldErrorMsg,
	requiredOccupationFieldErrorMsg,
	requiredMessageFieldErrorMsg
}

function validMobileFormat (mobileNumber) {
	return new RegExp(CONFIG.MOBILE_REGEX, 'i').exec(mobileNumber);
}

function validEmailFormat (emailAd) {
	return new RegExp(CONFIG.EMAIL_REGEX, 'i').test(emailAd);
}

function validBirthDateFormat (value) {
	var validBday = new RegExp(CONFIG.BIRTHDATE_REGEX, 'i').test(value);
	return (validBday && (new Date(value).getTime() <= new Date().getTime()));	
}

function validNameFormat (value) {
	return new RegExp(CONFIG.NAME_REGEX, 'i').test(value);
}

function validAmountFormat(value){
	return new RegExp(CONFIG.AMOUNT_REGEX, 'i').test(value);
}

function validAddressFormat(value){
	return new RegExp(CONFIG.ADDRESS_REGEX, 'i').test(value);
}

function validOccupationFormat(value){
	return new RegExp(CONFIG.OCCUPATION_REGEX, 'i').test(value);
}

function validMessageFormat(value){
	return new RegExp(CONFIG.MESSAGE_REGEX, 'i').test(value);
}

function noInputError (value) {
	return (value === '');
}

function requiredInputFieldErrorMsg (key, value, maxlength) {
	if(noInputError(value) || (maxlength > 0 && value.length > maxlength))
	{
		return 'Invalid ' + key;
	}
	else{
		return '';
	}
}

function requiredEmailFieldErrorMsg (value, maxlength) {
	if(noInputError(value) || (maxlength > 0 && value.length > maxlength))
	{
		return 'Invalid e-mail address';
	}
	else if(!validEmailFormat(value) || (value.length > maxlength))
	{
		return 'Invalid e-mail address';
	}
	else{
		return '';
	}
}

function requiredBirthDateFieldErrorMsg (value) {
	if(noInputError(value))
	{
		return 'Invalid birth date';
	}

	else if(!validBirthDateFormat(value))
	{
		return 'Invalid birth date';
	}
	else{
		return '';
	}
}

function requiredTourPackageFieldErrorMsg (key, value) {
	if(value === null)
	{
		return 'Invalid ' + key;
	}
	else{
		return '';
	}
}

function requiredNameFieldErrorMsg (key, value, maxlength) {
	if(noInputError(value) || !validNameFormat(value) || (maxlength > 0 && value.length > maxlength))
	{
		return 'Invalid ' + key;
	}
	else{
		return '';
	}
}

function requiredMobileFieldErrorMsg (key, value, maxlength) {
	if(noInputError(value) || !validMobileFormat(value) || (maxlength > 0 && value.length > maxlength))
	{
		return 'Invalid ' + key;
	}
	else{
		return '';
	}
}

function requiredAmountFieldErrorMsg(key, value, maxLength, maxAmount, minLength, minAmount){
	if(noInputError(value) || (maxLength > 0 && value.length > maxLength)){
		return 'Invalid ' + key;
	}
	else if(!validAmountFormat(value)){
		return 'Invalid ' + key;
	}
	else if ((value.length < minLength || value < minAmount) || (value.length > maxLength || value > maxAmount)){
		return 'Amount should be between '+ minAmount + ' and ' + maxAmount;
	}
	else{
		return '';
	}
}

function requiredAddressFieldErrorMsg (value, maxlength) {
	if(noInputError(value) || !validAddressFormat(value) || (maxlength > 0 && value.length > maxlength))
	{
		return 'Invalid address.';
	}else{
		return '';
	}
}

function requiredOccupationFieldErrorMsg (value, maxlength) {
	if(noInputError(value) || !validOccupationFormat(value) || (maxlength > 0 && value.length > maxlength))
	{
		return 'Invalid occupation.';
	}else if(!validOccupationFormat(value) || (value.length > maxlength)){
		return 'Invalid occupation.';
	}
	else{
		return '';
	}
}

function requiredMessageFieldErrorMsg (value, maxlength) {
	if(noInputError(value) || !validMessageFormat(value) || (maxlength > 0 && value.length > maxlength))
	{
		return 'Invalid message.';
	}
	else{
		return '';
	}
}